export default __webpack_public_path__ + "88bfe54.png";